// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "AthleteSignUpPage" + "-" + "ab5afc2b579ea1134fea" + ".css";
};